/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Platform } from 'react-native';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDNativeSystem, JDDevice } from '@jdreact/jdreact-core-lib';
import TabConBasicParams from './TabConBasicParams';
import TabContAppearancePrice from './TabContAppearancePrice';
import TabConGoodsOpinions from './TabConGoodsOpinions';
import HOCDelay from './HOCDelay';
import Store from '../services/goodsContrastPageStore/store';
import { IPublicPraiseTab, IPriceTab, IAttributeTab } from '../services/goodsContrastPageStore/domain';
import Loading from './Loading';
const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  tabControlPlaceHolder: {
    minWidth: getRpx(750),
    height: getRpx(90),
  },
  tabContent: {
    flexDirection: 'column',
    flex: 1,
    width: '100%',
  },
  tabContentBox: {
    // minWidth: getRpx(996),
  },
});
interface IStoreProps {
  store: {
    tabCtrlList: { text: string; checked: boolean }[];
    priceTab: IPriceTab;
    attributeTab: IAttributeTab;
    publicPraiseTab: IPublicPraiseTab;
  };
}
interface IProps extends IStoreProps {
  isReadOnly: boolean;
}
interface IState {}
class TabContent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      loadMore: false,
    };
  }
  _renderContent = (index: number) => {
    const { isReadOnly } = this.props;
    const map = new Map();
    map.set(0, <TabContAppearancePrice isReadOnly={isReadOnly} index={index} />);
    map.set(1, <TabConBasicParams index={index} />);
    map.set(2, <TabConGoodsOpinions isReadOnly={isReadOnly} index={index} />);
    return map.get(index);
  };
  render() {
    const {
      // priceTab, attributeTab, publicPraiseTab 放在render中保证re-render 更新数据
      store: { tabCtrlList, contentList, priceTab, attributeTab, publicPraiseTab },
      isReadOnly,
    } = this.props;
    return (
      <View style={styles.tabContentBox}>
        <View style={styles.tabControlPlaceHolder}></View>
        <View
          style={[
            styles.tabContent,
            {
              paddingBottom: Platform.OS !== 'web' ? getRpx(140) : getRpx(180),
            },
          ]}
        >
          {tabCtrlList.map((tab: any, index: number) => {
            if (tab.checked) {
              return (
                <View
                  style={
                    tabCtrlList[index].checked
                      ? null
                      : {
                          display: 'none',
                        }
                  }
                >
                  {this._renderContent(index)}
                </View>
              );
            } else {
              return null;
            }
          })}
        </View>
      </View>
    );
  }
}

const TabContentPageOberver = observer(TabContent);
const TabContentOberverWapper = (props: IProps) => <TabContentPageOberver {...props} store={Store} />;
export default TabContentOberverWapper;
